export const stepByStepLayouts = [{
	key: 'vertical',
	imgSrc: ''
}, {
	key: 'horizontal',
	imgSrc: ''
}];
